import * as React from 'react';

const GridViewFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="grid-view-fill_svg__eds-icon--grid-view-fill_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <g
            id="grid-view-fill_svg__eds-icon--grid-view-fill_corners"
            fillRule="evenodd"
            clipRule="evenodd"
        >
            <path d="M4 4h6v6H4zM14 4h6v6h-6zM14 14h6v6h-6zM4 14h6v6H4z" />
        </g>
    </svg>
);

GridViewFillSvg.displayName = 'GridViewFillSvg';
export default GridViewFillSvg;
